/* The server owns compatibility and availability; this element only adds its rendered variant. */
class PVCartLidOffer extends HTMLElement {
  static pending = false;

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.button = this.querySelector('[data-lid-add]');
    this.button.hidden = false;
    this.button.disabled = PVCartLidOffer.pending;
    this.button.addEventListener('click', () => this.addLids());
  }

  sectionsToRender() {
    const sections = [{ id: 'cart-icon-bubble', key: 'cart-icon-bubble', selector: '.shopify-section' }];
    if (document.querySelector('cart-drawer')) {
      sections.push({ id: 'CartDrawer', key: 'cart-drawer', selector: '#CartDrawer' });
    }
    for (const id of ['main-cart-items', 'main-cart-footer']) {
      const element = document.getElementById(id);
      if (element) sections.push({ id, key: element.dataset.id, selector: '.js-contents' });
    }
    return sections;
  }

  async addLids() {
    if (PVCartLidOffer.pending) return;
    PVCartLidOffer.pending = true;
    document.querySelectorAll('[data-lid-add]').forEach((button) => { button.disabled = true; });
    const status = document.getElementById('pv-cart-lid-status');
    const error = this.querySelector('[role="alert"]');
    const inDrawer = Boolean(this.closest('cart-drawer'));
    error.hidden = true;
    this.button.textContent = 'Adding…';
    this.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';
    let added = false;
    try {
      const sections = this.sectionsToRender();
      const properties = {};
      if (this.dataset.affiliate) properties._Affiliate = this.dataset.affiliate;
      if (this.dataset.affiliateCode) properties['_Affiliate code'] = this.dataset.affiliateCode;
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(this.dataset.variant), quantity: 1, properties }],
          sections: sections.map((section) => section.key),
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'These lids could not be added. Please try again.');
      added = true;
      // Check every fragment before touching the DOM. A successful add must never be retried after a render failure.
      const fragments = sections.map((section) => {
        const html = result.sections?.[section.key];
        const source = html && new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
        const target = document.getElementById(section.id);
        if (!source || !target) throw new Error('Cart refresh failed');
        return { target: target.querySelector(section.selector) || target, source };
      });
      for (const fragment of fragments) fragment.target.innerHTML = fragment.source.innerHTML;
      if (inDrawer) {
        // Native drawer replaces its overlay during a section refresh.
        const drawer = document.querySelector('cart-drawer');
        drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
        const focusTarget = drawer.querySelector('[data-lid-add]') || drawer.querySelector('.drawer__close');
        if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('.drawer__inner'), focusTarget);
        else focusTarget?.focus();
      } else {
        const focusTarget = document.querySelector('cart-items [data-lid-add]') || document.querySelector('cart-items h1');
        if (focusTarget) { focusTarget.setAttribute('tabindex', '-1'); focusTarget.focus(); }
      }
      if (status) status.textContent = `${this.dataset.title} added to your cart.`;
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: result });
      }
    } catch (cause) {
      if (added) {
        window.location.assign(window.routes?.cart_url || '/cart');
        return;
      }
      error.textContent = cause instanceof TypeError || cause instanceof SyntaxError
        ? 'We could not confirm the addition. Check your cart before trying again.'
        : cause.message;
      error.hidden = false;
    } finally {
      PVCartLidOffer.pending = false;
      document.querySelectorAll('[data-lid-add]').forEach((button) => { button.disabled = false; });
      this.button.textContent = 'Add 6 lids';
      this.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('pv-cart-lid-offer')) customElements.define('pv-cart-lid-offer', PVCartLidOffer);
